import { useState, useEffect } from 'react';
import axios from 'axios';
import Main from '../../../component/Main.jsx';
import ShowDetailDataGrid from "../../../component/common/dataGrid/ShowDetailDataGrid.jsx"
import useModalStore from '../../../zustand/store/useModalStore.js';

import { Search16w, AddCircle16w } from '../../../images/icons/icons_component.js';

const OperRegTrnList = () => {

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = String(today.getMonth() + 1).padStart(2, '0');

    const [searchParams, setSearchParams] = useState({
        searchFromdate: currentYear,
        searchTodate: currentYear,
        searchCheck1: currentMonth,
        searchCheck2: currentMonth,
    });

    const searchParamsAdditional = {};

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['상세보기', '기준년월', '실적 등록 명칭', '등록 기간', '생성일자', '수정일자']; //component화 
    const dataColumn = ['SEQ', 'IEM_ID', 'CD_NM', 'BEGIN_DE', 'CREAT_DT', 'UPDT_DT'];
    const apiCall = '/trmsapi/trnlst/operrsltRegTrnListSearch.do';
    const apiCntCall = '/trmsapi/trnlst/operrsltRegTrnListCnt.do';
    const excelFileName = '등록일정관리';
    const excelHead = ['순번', '기준년월', '실적 등록 명칭', '등록 기간', '생성일자', '수정일자'];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: true,
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0
    });

    const popupPropsInfo = {
        checked: ["SEQ"],
        localStorageName: "operRegTrnListData",
        popupAddress: "/nedis/trmsInfo/trms_operRegTrnList_popup.do",
        width: '630',
        height: '250'
    }

    if (searchParamsAdditional != null) {
        searchParamsAdditional.pageNum = parseInt(pageInfo.currentPage);
        searchParamsAdditional.displayRowsize = parseInt(pageInfo.itemsPerPage);
    }

    const totalObj = Object.assign({}, searchParams, searchParamsAdditional);

    const showNotiModal = useModalStore(state => state.showNotiModal);

    const fetchData = async () => {
        try {
            delete totalObj.validationCheckList;
            const response = await axios.get(apiCall,
                { params: totalObj }
            );
            setState(prev => ({
                ...prev,
                dataList: response.data,
                isSearched: true
            }));
            if (apiCntCall === '') {
                setPageInfo(prev => ({
                    ...prev,
                    totalItems: response.data.length
                }));
            } else {
                fetchDataCnt();
            }
            setState(prev => ({
                ...prev,
                isLoading: false
            }));
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }
    };

    const fetchDataCnt = async () => {
        try {
            const response = await axios.get(apiCntCall,
                { params: totalObj }
            );
            setPageInfo(prev => ({
                ...prev,
                totalItems: response.data
            }));
        } catch (error) {
            console.error('데이터 카운터 중 오류 발생:', error);
        }
    };

    useEffect(() => {
        if (state.isSearched) {
            setState(prev => ({
                ...prev,
                isLoading: true
            }));
            fetchData();
        }
    }, [pageInfo.currentPage, searchParams.searchGubunS]);

    const search = () => {
        const fromDate = Number(searchParams.searchFromdate + searchParams.searchCheck1);
        const toDate = Number(searchParams.searchTodate + searchParams.searchCheck2);
        if (fromDate > toDate) {
            showNotiModal('검색 종료일자가 검색 시작일자보다 과거일 수 없습니다.');
            return;
        }
        setState(prev => ({
            ...prev,
            isSearched: false,
            isLoading: true
        }));
        setPageInfo(prev => ({
            ...prev,
            currentPage: 1,
        }));
        fetchData();
    };

    const add = () => {
        const senData = {
            flag: "add",
            IEM_ID: '',
        }

        let popup = null;

        if (state.isSearched) {
            localStorage.setItem(popupPropsInfo.localStorageName, JSON.stringify(senData));
            popup = window.open(popupPropsInfo.popupAddress, "팝업", "scrollbars=1, resizable=0, width=630, height=250, top=30, left=30");
        }
    };

    const onHandlePerPage = (e) => {
        setPageInfo(prev => ({
            ...prev,
            itemsPerPage: parseInt(e.target.value)
        }));
    };

    const perPageOptions = Array.from({ length: 10 }, (_, i) => {
        const perPage = (i + 1) * 10;
        return (
            <option key={perPage} value={perPage}>
                -- {perPage}건 씩 조회 --
            </option>
        );
    });

    useEffect(() => {
        search();
    }, []);

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="20%" />
                        <col width="80%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>기준년월 조회기간</th>
                            <td>
                                <select id="searchFromdate"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                >
                                    {
                                        Array.from({ length: 12 }, (_, i) => {
                                            const year = (currentYear + 1 - i).toString();
                                            return (
                                                <option key={year} value={year}>
                                                    {year}년
                                                </option>
                                            );
                                        })
                                    }
                                </select>
                                &nbsp;
                                <select id="searchCheck1"
                                    name="searchCheck1"
                                    value={searchParams.searchCheck1}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 12 }, (_, i) => {
                                        const month = (i + 1).toString().padStart(2, '0');
                                        return (
                                            <option key={month} value={month}>
                                                {month}월
                                            </option>
                                        );
                                    })}
                                </select>
                                &nbsp;
                                ~
                                &nbsp;
                                <select id="searchTodate"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                >
                                    {
                                        Array.from({ length: 12 }, (_, i) => {
                                            const year = (currentYear + 1 - i).toString();
                                            return (
                                                <option key={year} value={year}>
                                                    {year}년
                                                </option>
                                            );
                                        })
                                    }
                                </select>
                                &nbsp;
                                <select id="searchCheck2"
                                    name="searchCheck2"
                                    value={searchParams.searchCheck2}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 12 }, (_, i) => {
                                        const month = (i + 1).toString().padStart(2, '0');
                                        return (
                                            <option key={month} value={month}>
                                                {month}월
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='search_btn_wrapper'>
                <span className='total_items'>전체&nbsp;<strong className='tr_primary'>{pageInfo.totalItems}</strong>건</span>
                <div className='btn_container'>
                    <select
                        name="itemsPerPage"
                        value={pageInfo.itemsPerPage}
                        className='page_select'
                        onChange={onHandlePerPage}
                    >
                        {perPageOptions}
                    </select>
                    <button onClick={search} disabled={state.isLoading ? 'disabled' : ''} className='search_btn bg_tr_primary'><Search16w />조회</button>
                    <button onClick={add} disabled={state.isLoading ? 'disabled' : ''} className='search_btn bg_co_black'><AddCircle16w />추가</button>
                </div>
            </div>
            <ShowDetailDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                searchParams={searchParams}
                popupPropsInfo={popupPropsInfo}
            />
        </Main>
    )
}

export default OperRegTrnList;